<template>
  <div class="container">
    <div @click="goback()">
      <div class="navi">
          <span class="icon-arrow-left"></span>
      </div>
    </div>
    
    <div class="title">费用详情</div>
    <div class="weui-form-preview" v-if="orderDetail.payment_amount>0 || orderDetail.order_amount>20">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label color-black">总费用</label>
                  <em class="weui-form-preview__value color-orange" v-if="orderDetail.pay_status==1||orderDetail.pay_status==2">{{Number(orderDetail.payment_amount)+Number(orderDetail.deposit_amount) | numeral('$0,0.00')}}</em>
                  <em class="weui-form-preview__value color-orange" v-if="orderDetail.pay_status==3||orderDetail.pay_status==4">{{orderDetail.order_amount | numeral('$0,0.00')}}</em>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">基础费</label>
                  <em class="weui-form-preview__value">{{orderDetail.details.labor_cost | numeral('$0,0.00')}}</em>
              </div>
          </div>
          <div class="weui-form-preview__bd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">户型</label>
                  <span class="weui-form-preview__value">
                    {{orderDetail.details.house_type_name}}
                  </span>
              </div>
              <div class="weui-form-preview__item" v-show="orderDetail.details.house_layout!=1562662349">
                  <label class="weui-form-preview__label">清洁房间</label>
                  <span class="weui-form-preview__value">
                    {{orderDetail.details.house_layout_name}} 
                  </span>
              </div>

              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">服务人员</label>
                  <span class="weui-form-preview__value">{{orderDetail.cost_data.operates_num}}人</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">开始时间</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.service_start_time | moment("HH:mm:ss")}}</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">结束时间</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.service_end_time | moment("HH:mm:ss")}}</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">暂停时长</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.service_pause_second}}秒</span>
              </div>
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">工作时长</label>
                  <span class="weui-form-preview__value">{{orderDetail.details.work_time}}</span>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">复式费用</label>
                  <em class="weui-form-preview__value">{{orderDetail.details.duplex_cost| numeral('$0,0.00')}}</em>
              </div>
          </div>
          <div class="weui-form-preview__bd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">类型</label>
                  <span class="weui-form-preview__value" >{{house_type_duplex}}</span>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">地毯清洁费用</label>
                  <em class="weui-form-preview__value">{{orderDetail.details.carpet_cost| numeral('$0,0.00')}}</em>
              </div>
          </div>
          <div class="weui-form-preview__bd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">详情</label>
                  <span class="weui-form-preview__value" v-show="orderDetail.details.carpet_name">{{orderDetail.details.carpet_name}}</span>
                  <span class="weui-form-preview__value" v-show="!orderDetail.details.carpet_name">无</span>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">额外清洁项目</label>
                  <em class="weui-form-preview__value">{{orderDetail.details.extra_cost | numeral('$0,0.00')}}</em>
              </div>
          </div>
          <div class="weui-form-preview__bd" v-if="Object.keys(this.orderDetail.details.extra_data).length">
              <div class="weui-form-preview__item" v-for="item in orderDetail.details.extra_data">
                  <label class="weui-form-preview__label">{{item.name}} x {{item.qty}} </label>
                  <span class="weui-form-preview__value">{{item.price | numeral('$0,0.00')}}</span>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">GST费用 (10%)</label>
                  <em class="weui-form-preview__value">{{orderDetail.gst_amount | numeral('$0,0.00')}}</em>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">其他费用</label>
                  <em class="weui-form-preview__value">{{orderDetail.other_amount | numeral('$0,0.00')}}</em>
              </div>
          </div>
          <div class="weui-form-preview__bd"  v-if="Object.keys(this.orderDetail.other_amount_data).length">
              <div class="weui-form-preview__item" v-for="item in orderDetail.other_amount_data">
                  <label class="weui-form-preview__label">{{item.name}}</label>
                  <span class="weui-form-preview__value">{{item.price | numeral('$0,0.00')}}</span>
              </div>
          </div>
    </div>
    <br>
    <div class="weui-form-preview">
          <div class="weui-form-preview__hd">
              <div class="weui-form-preview__item">
                  <label class="weui-form-preview__label">优惠减免</label>
                  <em class="weui-form-preview__value">-{{orderDetail.offers_amount | numeral('$0,0.00')}}</em>
              </div>
          </div>
    </div>
    <br>
    <div class="btn-box-fix">
      <div class="btn-container">

		      <router-link  class="btn active" :to="orderURL">返回
          </router-link>
      </div>
    </div>

    <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取订单</p>
              </div>
          </div>
    </transition>



  </div>


</template>

<script>
import qs from 'qs'

export default {
  name: 'order-detail',
  data () {
    return {
      isSending:false,
      isSendingPricing:false,
      isLeaving:false,
      pricing:{},
      orderDetail: {
        "order_id": "",
        "type_id": "",
        "order_number": "",
        "member_id": "",
        "member_name": "",
        "member_phone": "",
        "member_mail": "",
        "service_date": "",
        "service_time": "",
        "deposit_amount": "",
        "offers_amount": "",
        "other_amount": "",
        "payment_amount": "",
        "order_amount": "",
        "gst_amount": "",
        "cancelfee_amount": "",
        "order_status": "",
        "pay_status": "",
        "prepaid_time": "",
        "pay_time": "",
        "created": "",
        "operates": "",
        "other_amount_data": "",
        "invoices_url": "",
        "type_name": "",
        "order_status_name": "",
        "pay_status_name": "",
        "cost_data": {
            "type_id": "",
            "house_layout": "",
            "floor": "",
            "duplex_floor": "0",
            "carpet": "0",
            "operates_num": 1
        },
        "details": {
            "house_type": "",
            "house_layout": "",
            "address": {
                "address_name": "",
                "address_phone": "",
                "address_state": "",
                "address_suburb": "",
                "address_street": "",
                "address_postcode": ""
            },
            "floor": "",
            "parking": "",
            "carpet": "",
            "is_duplex": "",
            "duplex_floor": "",
            "labor_cost": "",
            "stairs_cost": "",
            "duplex_cost": "",
            "carpet_cost": "",
            "extra_cost": "",
            "service_start_time": "",
            "service_end_time": "",
            "service_pause_time": "",
            "service_pause_second": "",
            "service_period": "",
            "work_time": "",
            "house_type_name": "",
            "house_layout_name": "",
            "floor_name": "",
            "parking_name": "",
            "carpet_name": "",
            "attribute": [],
            "extra_data": []
        },
        "expiration_time": 0,
        "lifecycle_text": "",
        "lifecycle_status": 0
      },
      order:{
        data:{
        }
      }
    }
  },
  methods: {
    getData(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;
        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;

        this.axios.post(this.apiURL()+'/Order/orderInfo', qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderDetail = response.data.data;
          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
    goback(){
      this.$router.push(this.orderURL);
    },
    dataLint(name,value){
      let result ="";

      if (name == "duplex_floor"){
        switch (value) {
          case "0":
            result = "0"
            break;
          case "1558077283":
            result = "2"
            break;
          case "1558077310":
            result = "3"
            break;
          case "1558077329":
            result = "4"
            break;
          case "1558077340":
            result = "5"
            break;
          default:
            console.log("5");
        }
      }

      if (name == "house_type"){
        switch (value) {
          case "1552109724":
            result = "1"
            break;
          case "1552109729":
            result = "2"
            break;
          case "1552109735":
            result = "3"
            break;
          case "1552109742":
            result = "4"
            break;
          case "1558079273":
            result = "5"
            break;
          case "1552109747":
            result = "6"
            break;
          default:
            console.log("5");
        }
      }

      if (name == "parking") {
        switch (value) {
          case "1551410080":
            result = "我有停车位"
            break;
          case "1551410087":
            result = "已约停车位"
            break;
          case "1551410093":
            result = "无法提供停车位"
            break;
          default:
            console.log("6");
        }
      }

      if (name == "floor") {
        switch (value) {
          case "1551412462":
            result = "有电梯/住G层"
            break;
          case "1551412475":
            result = "1层 无电梯"
            break;
          case "1551412486":
            result = "2层 无电梯"
            break;
          case "1551412499":
            result = "3层 无电梯"
            break;
          case "1551412509":
            result = "4层 无电梯"
            break;
          case "1551412525":
            result = "5层 无电梯"
            break;
          case "1551412535":
            result = "5层以上 无电梯"
            break;
          default:
            console.log("7");
        }
      }
      return result;
    },
  },
  computed: {
    orderURL: function (){
      let theString = this.$route.query.id;
      return '/cleanex/order-detail?id=' + theString;
    },

    house_type_duplex: function () {
      let type = '';
      let duplex = '';
      
      switch (this.orderDetail.details.is_duplex) {
        case "0":
          duplex = '非复式'
          break;
        case "1":
          duplex = ''
          break;
        default:
          console.log("2");
      }
      let result = type + " " + duplex;
      if(this.orderDetail.details.is_duplex=="1"){
        result = result +this.orderDetail.details.duplex_floor_name;
      }
      return result;
    },
    service_period: function () {
      let result = '';
      switch (this.orderDetail.details.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("service_period conv error");
      }
      return result;
    },

  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ {
  .weui-cell__ft{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:70%;
    font-size:0.9em;
  }

  .weui-msg__title{
    font-size:1.1em;
    margin-bottom:0;
  }

  .park-assist{
      text-align:center;
      color:#fe9567;
  }

  .prepay-img{
    width:100%;
  }
} 

</style>



// WEBPACK FOOTER //
// src/pages/cleanEx/order-detail-price.vue